// Shared palette for plan badges and distribution dots in App and OPS.
const styles = {
  free: { badge: 'bg-gray-100 text-gray-800', dot: 'bg-gray-400' },
  starter: { badge: 'bg-blue-100 text-blue-800', dot: 'bg-blue-500' },
  pro: { badge: 'bg-purple-100 text-purple-800', dot: 'bg-purple-500' },
  business: { badge: 'bg-green-100 text-green-800', dot: 'bg-green-500' },
  business_trial: { badge: 'bg-orange-100 text-orange-800', dot: 'bg-orange-500' },
  enterprise: { badge: 'bg-indigo-100 text-indigo-800', dot: 'bg-indigo-500' },
};

export function getPlanStyle(plan) {
  const code = String(plan || '').toLowerCase();
  const aliases = { trial: 'free', growth: 'pro' };
  return styles[aliases[code] || code] || styles.free;
}
